<template>
  <div>
    <div v-if="show" class="modal">
      <AbnormalPrompt
        :iconUrl="iconUrl"
        firstTitle="网络不给力"
        buttonText="刷新"
        SecondTitle="网络连接错误，请检查网络"
        @buttonClick="buttonClick"
      />
    </div>
  </div>
</template>

<script setup>
import AbnormalPrompt from '../abnormal-prompt/index.vue';

import { iconUrl } from './base64.js';
import { ref } from 'vue';
import { usePermission } from '@/store/modules/permission';

import { useEventListener } from '@vant/use';

const emits = defineEmits(['buttonClick']);

const buttonClick = () => {
  emits('buttonClick');
};

const permissionStore = usePermission();

const show = ref(false);

useEventListener('offline', () => {
  show.value = true;
  permissionStore.setNoNetState(true);
});

useEventListener('online', () => {
  show.value = false;
  permissionStore.setNoNetState(false);
});

</script>

<style lang="scss" scoped>
.modal{
  position:fixed;
  z-index: 10014;
  width: 100vw;
  height: 100vh;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  background-color: #fff;
}
</style>
